// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  background: whitesmoke;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 998 !important;
  position: absolute;
}

.lds-empyrean {
  z-index: 999 !important;
  position: absolute;
  display: grid;
  grid-auto-flow: column;
  align-items: end;
  opacity: 0.8;
}
.lds-empyrean .loader-message {
  background-color: transparent;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  font-weight: bolder;
  height: 60%;
  justify-content: center;
  opacity: 1;
  position: inherit;
  text-align: center;
  text-transform: uppercase;
  transition: all 1s ease-in-out;
  white-space: pre;
}

.lds-empyrean div {
  background: #fff;
}

.lds-empyrean div:nth-child(1) {
  filter: brightness(0.5);
}

.lds-empyrean div:nth-child(2) {
  filter: brightness(0.55);
}

.lds-empyrean div:nth-child(3) {
  filter: brightness(0.6);
}

.lds-empyrean div:nth-child(4) {
  filter: brightness(0.65);
}

.lds-empyrean div:nth-child(5) {
  filter: brightness(0.7);
}

.lds-empyrean div:nth-child(6) {
  filter: brightness(0.75);
}

.lds-empyrean div:nth-child(7) {
  filter: brightness(0.8);
}

.lds-empyrean div:nth-child(8) {
  filter: brightness(0.85);
}

.lds-empyrean div:nth-child(9) {
  filter: brightness(0.9);
}

.plain {
  filter: brightness(1) !important;
  opacity: 1 !important;
}

@keyframes lds-empyrean {
  0% {
    opacity: 0.45;
    height: 50%;
  }
  33% {
    opacity: 0.75;
    height: 100%;
  }
  66% {
    opacity: 0.75;
    height: 100%;
  }
  100% {
    opacity: 0.45;
    height: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/empyrean-loader/empyrean-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,uEAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AACF;AACE;EACE,6BAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACE,gBAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,wBAAA;AAGF;;AADA;EACE,uBAAA;AAIF;;AAFA;EACE,wBAAA;AAKF;;AAHA;EACE,uBAAA;AAMF;;AAJA;EACE,wBAAA;AAOF;;AALA;EACE,uBAAA;AAQF;;AANA;EACE,wBAAA;AASF;;AAPA;EACE,uBAAA;AAUF;;AAPA;EACE,gCAAA;EACA,qBAAA;AAUF;;AAPA;EACE;IACE,aAAA;IACA,WAAA;EAUF;EARA;IACE,aAAA;IACA,YAAA;EAUF;EARA;IACE,aAAA;IACA,YAAA;EAUF;EARA;IACE,aAAA;IACA,WAAA;EAUF;AACF","sourcesContent":[".loader-container {\r\n  background: whitesmoke;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);\r\n  padding: 20px;\r\n  z-index: 998 !important;\r\n  position: absolute;\r\n}\r\n\r\n.lds-empyrean {\r\n  z-index: 999 !important;\r\n  position: absolute;\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  align-items: end;\r\n  opacity: 0.8;\r\n\r\n  .loader-message {\r\n    background-color: transparent;\r\n    color: white;\r\n    display: -webkit-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 1rem;\r\n    font-weight: bolder;\r\n    height: 60%;\r\n    justify-content: center;\r\n    opacity: 1;\r\n    position: inherit;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: all 1s ease-in-out;\r\n    white-space: pre;\r\n  }\r\n}\r\n.lds-empyrean div {\r\n  background: #fff;\r\n}\r\n.lds-empyrean div:nth-child(1) {\r\n  filter: brightness(0.5);\r\n}\r\n.lds-empyrean div:nth-child(2) {\r\n  filter: brightness(0.55);\r\n}\r\n.lds-empyrean div:nth-child(3) {\r\n  filter: brightness(0.6);\r\n}\r\n.lds-empyrean div:nth-child(4) {\r\n  filter: brightness(0.65);\r\n}\r\n.lds-empyrean div:nth-child(5) {\r\n  filter: brightness(0.7);\r\n}\r\n.lds-empyrean div:nth-child(6) {\r\n  filter: brightness(0.75);\r\n}\r\n.lds-empyrean div:nth-child(7) {\r\n  filter: brightness(0.8);\r\n}\r\n.lds-empyrean div:nth-child(8) {\r\n  filter: brightness(0.85);\r\n}\r\n.lds-empyrean div:nth-child(9) {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n.plain {\r\n  filter: brightness(1) !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n@keyframes lds-empyrean {\r\n  0% {\r\n    opacity: 0.45;\r\n    height: 50%;\r\n  }\r\n  33% {\r\n    opacity: 0.75;\r\n    height: 100%;\r\n  }\r\n  66% {\r\n    opacity: 0.75;\r\n    height: 100%;\r\n  }\r\n  100% {\r\n    opacity: 0.45;\r\n    height: 50%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
